import { FailureReason } from "@basic-document-viewer/api/src/domain/failure-reasons";

export enum UiFailureReasons {
  Render = "Render",
  Generic = "Generic",
}

export type ErrorKey = FailureReason | UiFailureReasons;
